import initState from './initState';

export default {
	SET_COLUMN(state,data){
		state.defaultColumn = data
	},
	SET_THEME(state,data){
		state.theme[data.label][data.child] = data.value
	},
	SET_USER(state,data){
		state.user = data
	},
	SET_FORM(state,data){
		state.form = data
	},
	SIGNOUT: (state) => {
	    const initial = initState();
	    Object.keys(initial).forEach((key) => {
	      state[key] = initial[key];
	    });
	},
	SET_TAB_PAGE(state,data){
		state.tabPage = data
	},  
};
